<template>
  <div class="container pt-3 pb-5">
    <h1 class="my-4">My Wishlist</h1>
    <button @click="goBack" class="btn btn-outline-dark mb-3">
      &#8592; Buy More Books
    </button>
    <div>  
      <div v-if="wishlistItems.length === 0" class="alert alert-info">
        Your wishlist is empty.
      </div>
      <div v-else class="list-group">
        <div
          v-for="item in wishlistItems"
          :key="item._id"
          class="list-group-item d-flex align-items-center justify-content-between"
        >
          <div class="d-flex align-items-center">
            <img
              :src="item.images?.[0] ? `${BASE_IMAGE_PREFIX}/${item.images[0]}` : 'https://libreture.com/static/images/book-placeholder.png'"
              class="img-thumbnail me-3"
              alt="Book Cover"
              style="width: 75px; height: auto"
            />
            <div>
              <h5 class="mb-1">{{ item.title }}</h5>
              <p
                v-if="item.productCategory !== 'stationary'"
                class="mb-1"
              >
                Author: {{ item.author }}
              </p>
              <p class="mb-1">Price: {{ item.price }}</p>
            </div>
          </div>
          <div>
            <button
              class="btn btn-dark btn-sm mx-3"
              @click="addToCart(item)"
            >
              Add to cart
            </button>
            <button
              class="btn btn-danger btn-sm"
              @click="removeFromWishlist(item)"
            >
              Remove
            </button>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
          <button class="btn btn-dark">
            <router-link class="nav-link" to="/cart">
              Go To Cart &#8594;
            </router-link>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_IMAGE_PREFIX } from '@/globals';

export default {
  data() {
    return {
      BASE_IMAGE_PREFIX,
    }
  },
  computed: {
    wishlistItems() {
      return this.$store.getters.wishlistItems;
    },
  },
  methods: {
    addToCart(book) {
        const payload = {
          product: {
              _id: book._id,
              title: book.title,
              author: book.author,
              images: book.images,
              productCategory: book.productCategory
          },
          variant: book.variant || book.minVariant,
          quantity: 1
      }
      this.$store.dispatch("addToCart", payload);
      this.removeFromWishlist(book)
      this.$root.showToast({
        message: "Item added to cart",
        status: "success",
        duration: 3000,
      });
    },
    removeFromWishlist(item) {
      this.$store.dispatch("removeFromWishlist", item);
      this.$root.showToast({
        message: "Item removed from wishlist",
        status: "success",
        duration: 3000,
      });
    },
    goBack() {
      this.$router.go(-1); // Or use this.$router.back();
    },
  },
};
</script>

<style scoped>
.list-group-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.img-thumbnail {
  max-width: 75px; /* Ensure the image is small */
  max-height: 100px; /* Optional: control height */
}
</style>
